module.exports = __webpack_public_path__ + "img/poviewer-icon.ad064353.svg";